import { CrudStoreItemHpScout } from '../models/CrudStoreItemHpScout'

interface IFormKey {
  formId: number
  code: string
}
interface ICSHubForms {
  [CrudStoreItemHpScout.CSHubManagement]: IFormKey
  [CrudStoreItemHpScout.CSHubManagementItems]: IFormKey
  [CrudStoreItemHpScout.CDPReportM01]: IFormKey
  [CrudStoreItemHpScout.SustainabilityReportM02]: IFormKey
  [CrudStoreItemHpScout.GHGInventoryM03]: IFormKey
  [CrudStoreItemHpScout.CDPReportDisclosureM04]: IFormKey
  [CrudStoreItemHpScout.CarbonReductionRoadmapM05]: IFormKey
  [CrudStoreItemHpScout.ReductionOfCarbonEmissionM06]: IFormKey
  [CrudStoreItemHpScout.CorporateRoadmapM07]: IFormKey
  [CrudStoreItemHpScout.GHGGoalsM08]: IFormKey
  [CrudStoreItemHpScout.CircularEconomyPrinciplesM09]: IFormKey
  [CrudStoreItemHpScout.LanetPartnerM10]: IFormKey
  [CrudStoreItemHpScout.ConductTrainingM11]: IFormKey
  [CrudStoreItemHpScout.HpLifeM12]: IFormKey
  [CrudStoreItemHpScout.HpLifeCommunityM13]: IFormKey
  [CrudStoreItemHpScout.DEIGoalsM14]: IFormKey
  [CrudStoreItemHpScout.SpendAMinimum10PercM15]: IFormKey
  [CrudStoreItemHpScout.SustainabilityCampaignM16]: IFormKey
  [CrudStoreItemHpScout.SupplierEngageM17]: IFormKey
  [CrudStoreItemHpScout.SupplierParticipationIntoResearchM18]: IFormKey
  [CrudStoreItemHpScout.CSPartnerInfo]: IFormKey
  [CrudStoreItemHpScout.CSContactInfo]: IFormKey
}

const prodData: ICSHubForms = {
  [CrudStoreItemHpScout.CSHubManagement]: {
    formId: 975,
    code: 'csih-report',
  },
  [CrudStoreItemHpScout.CSHubManagementItems]: {
    formId: 975,
    code: 'csih-report-initiatives',
  },
  [CrudStoreItemHpScout.CDPReportM01]: {
    formId: 1297,
    code: 'csih-cdp-report-submit-m01',
  },
  [CrudStoreItemHpScout.SustainabilityReportM02]: {
    formId: 1298,
    code: 'csih-sustainability-report-m02',
  },
  [CrudStoreItemHpScout.GHGInventoryM03]: {
    formId: 1299,
    code: 'csih-ghg-inventory-m03',
  },
  [CrudStoreItemHpScout.CDPReportDisclosureM04]: {
    formId: 1300,
    code: 'csih-cdp-report-disclosure-m04',
  },
  [CrudStoreItemHpScout.CarbonReductionRoadmapM05]: {
    formId: 1301,
    code: 'csih-carbon-reduction-roadmap-m05',
  },
  [CrudStoreItemHpScout.ReductionOfCarbonEmissionM06]: {
    formId: 1302,
    code: 'csih-reduction-of-carbon-emission-m06',
  },
  [CrudStoreItemHpScout.CorporateRoadmapM07]: {
    formId: 1303,
    code: 'csih-corporate-roadmap-m07',
  },
  [CrudStoreItemHpScout.GHGGoalsM08]: {
    formId: 1304,
    code: 'csih-ghg-goals-m08',
  },
  [CrudStoreItemHpScout.CircularEconomyPrinciplesM09]: {
    formId: 1305,
    code: 'csih-circular-economy-principles-m09',
  },
  [CrudStoreItemHpScout.LanetPartnerM10]: {
    formId: 1306,
    code: 'csih-lanet-partner-m10',
  },
  [CrudStoreItemHpScout.ConductTrainingM11]: {
    formId: 1307,
    code: 'csih-conduct-training-m11',
  },
  [CrudStoreItemHpScout.HpLifeM12]: {
    formId: 1308,
    code: 'csih-hp-life-m12',
  },
  [CrudStoreItemHpScout.HpLifeCommunityM13]: {
    formId: 1309,
    code: 'csih-hp-life-community-m13',
  },
  [CrudStoreItemHpScout.DEIGoalsM14]: {
    formId: 1310,
    code: 'csih-dei-goals-m14',
  },
  [CrudStoreItemHpScout.SpendAMinimum10PercM15]: {
    formId: 1311,
    code: 'csih-spend-a-minimum-of-10-m15',
  },
  [CrudStoreItemHpScout.SustainabilityCampaignM16]: {
    formId: 1312,
    code: 'csih-sustainability-campaign-m16',
  },
  [CrudStoreItemHpScout.SupplierEngageM17]: {
    formId: 1313,
    code: 'csih-supplier-engage-m17',
  },
  [CrudStoreItemHpScout.SupplierParticipationIntoResearchM18]: {
    formId: 1314,
    code: 'csih-supplier-participation-into-research-m18',
  },
  [CrudStoreItemHpScout.CSPartnerInfo]: {
    formId: 1573,
    code: 'cs-partner-info-1573',
  },
  [CrudStoreItemHpScout.CSContactInfo]: {
    formId: 1574,
    code: 'cs-contacts-info-1574',
  },
}

export const GetCSHubFormKey = (key: string) => {
  return prodData[key]
}
